import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { E5ConfigurationService as e5Config } from 'e5core-angular-services';
import { BehaviorSubject } from 'rxjs';
import { WorkItemModel } from '../../models/work-item';
import { FileUploadModel } from '../../models/file-upload.model';
import { Guid } from 'guid-typescript';
import { WorkAttachmentAddEvent } from '../../events/work-attachment-add-event';
import { UiStyleService } from '../../services/ui-style.service';

@Component({
  selector: 'e5core-ui-file-upload',
  templateUrl: './e5core-ui-file-upload.component.html',
  styleUrls: ['./e5core-ui-file-upload.component.css']
})
export class E5coreUiFileUploadComponent implements OnInit {

  @Input() workItem$: BehaviorSubject<WorkItemModel>;
  @Input() fileUpload$: BehaviorSubject<FileUploadModel>;
  @Input() uploadToUrl: string = "";
  @Input() acceptedFileExtensions: string = ".pdf,.doc,.docx,.text,.txt,.jpg,.jpeg,.tif,.tiff,.png,.gif,.xls,.xslx,.ppt,.pptx,.vsd,.vsdx";
  @Input() maxFileSize: string = "20971520";

  @Output() uploadEvent = new EventEmitter<WorkAttachmentAddEvent>();

  isInitialised : boolean = false;
  actualUploadToUrl : string;

  constructor(public style:UiStyleService, private config: e5Config) { }

  ngOnInit() {
    if (this.workItem$ == null && this.uploadToUrl == "") {
      console.error('e5core-ui-file-upload either uploadToUrl needs to be specified or [workItem$] must have a BehaviorSubject<WorkItemModel>');
      return ;
    }

    this.DetermineUploadUrl();
  }

  onUploadEvent(event) {
    var wid = this.workItem$.getValue().workId;
    
    this.uploadEvent.emit({workId: wid, id: null, name: null, fullUrl: null});
  }

  private DetermineUploadUrl() {
    var baseUrl = this.config.settings.apiServer.baseUrl;
    var scope = this.config.settings.apiServer.scope;

    this.actualUploadToUrl = this.uploadToUrl;
    if (typeof this.workItem$ != 'undefined') {
      if (this.uploadToUrl == "") {
        this.workItem$.subscribe(w => {
          this.actualUploadToUrl = `${baseUrl}/${scope}/api/Attachment/Add/${w.workId}`;

          if (typeof this.workItem$ != 'undefined' && this.workItem$.getValue().workId && this.workItem$.getValue().workId != Guid.EMPTY) {
            this.isInitialised = true;
          }
        });
      }
    }
  }
}
